module.exports = __webpack_public_path__ + "static/img/banner.4a46a2d4.png";